import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import PoweredbyLogo from '../../styles/img/DiyFormImage/dashboard/Poweredby.svg';
import formIcon from '../../styles/img/DiyFormImage/dashboard/formIcon.svg';
import logoutIcon from '../../styles/img/DiyFormImage/dashboard/logout.svg';
import receiptsIcon from '../../styles/img/DiyFormImage/dashboard/receipt.svg';
import qfixLogo from '../../styles/img/logo/logoWhite.svg';
import Logo from './Logo';


export default function LeftMenu() {

    const [activeTab, setActiveTab] = useState("forms");

    const navigate = useNavigate()
    const location=useLocation()


    useEffect(()=>{
        let tab="receipts"
        if(location?.pathname.includes('dashboard')){
            tab="forms"
        }
        setActiveTab(tab)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])
    
    const handleHomeClick = () => {
        navigate("/app/dashboard")
        setActiveTab("forms")
    }

    const handleReceipts = () => {
        navigate("/app/receipt")
        setActiveTab("receipts")
    }

    function renderForms() {
        return (
            <div className='menu-container' onClick={handleHomeClick}>
                <div className={`menu-image-container ${activeTab === "forms" ? "active" : ''}`}>
                    <img src={formIcon} alt="" />
                </div>
                <span className={`label-${activeTab === "forms" ? "active" : "inactive"}`}>Forms</span>
            </div>
        )
    }


    function renderReceipts() {
        return (
            <div className='menu-container' onClick={handleReceipts}>
                <div className={`menu-image-container ${activeTab === "receipts" ? "active" : ''}`}>
                    <img src={receiptsIcon} alt="" />
                </div>
                <span className={`label-${activeTab === "receipts" ? "active" : "inactive"}`}>Receipts</span>
            </div>
        )
    }

    const renderLogo = () => {
        return (
            <div className='logo-container hidden-m'>
                <Logo qfixLogo={qfixLogo} />
            </div>
        );
    };

    return (
        <div className={`left-menu-container ${(activeTab === "forms" || activeTab === "ivoice") ? "sidebarSubmenuOpen" : ''}`}>
            <div className='h-[100vh] w-[96px] SideMenuBox'>
                {renderLogo()}
                <div className='new-border-bottom hidden-m'></div>
                    <div className='mainMenu flex md:flex-col gap-[14px]'>
                        {renderForms()}
                        {renderReceipts()}
                    </div>
                    
                <div className='menu-container' style={{'position': 'absolute','bottom': '80px'}} onClick={()=>navigate("/app/logout")}>
                    <div className={`menu-image-container ${activeTab === "Logout" ? "active" : ''}`}>
                        <img src={logoutIcon} alt="" style={{'background': 'white'}} />
                    </div>
                    <span className={`f-22 label-${activeTab === "Logout" ? "active" : "inactive"}`}>Logout</span>
                </div>
                <div className='bottom-align hidden-m'>
                    <img src={PoweredbyLogo} alt="" />
                </div>
            </div>
        </div>
    )
}
